import { Box, VStack } from '@chakra-ui/react';

import { StickyAd } from '@/components/atoms';

type StickyAdData = {
  __typename?: 'StickyAdEntity';
  id?: string | null;
  attributes?: {
    __typename?: 'StickyAd';
    headingAd: string;
    textAd: string;
    buttonCaptionAd: string;
    buttonUrlAd: string;
    hasDarkBackground: boolean;
    imageAd?: {
      __typename?: 'UploadFileEntityResponse';
      data?: {
        __typename?: 'UploadFileEntity';
        attributes?: {
          __typename?: 'UploadFile';
          url: string;
          alternativeText?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

type StickyAdsContainerProps = {
  stickyAds: StickyAdData[];
};

export const StickyAdsContainer = ({ stickyAds }: StickyAdsContainerProps) => {
  if (!stickyAds || stickyAds.length === 0) {
    return null;
  }

  return (
    <Box mt="60px" alignSelf="center" w={{ base: '100%', xl: 'auto' }}>
      <VStack spacing={6} align="center" justify="center">
        {stickyAds
          .filter((ad) => ad.id && ad.attributes)
          .map((ad) => (
            <StickyAd
              key={ad.id}
              headingAd={ad.attributes!.headingAd}
              textAd={ad.attributes!.textAd}
              buttonCaptionAd={ad.attributes!.buttonCaptionAd}
              buttonUrlAd={ad.attributes!.buttonUrlAd}
              hasDarkBackground={ad.attributes!.hasDarkBackground}
              imageAd={ad.attributes!.imageAd}
            />
          ))}
      </VStack>
    </Box>
  );
};
